import React from "react";
import styled from "styled-components";

export default props => {
  const { leftIcon, headerTitle } = props;
  return (
    <HeaderTitle>
      <div
        style={{ width: "40px", height: "40px" }}
        onClick={leftIcon ? leftIcon.action : e => e.preventDefault}>
        {leftIcon && <img src={leftIcon.imgSrc} />}
        {/* IC.etc.ICON_CHEVRON_LEFT */}
      </div>
      {/* <div>약국정보</div> */}
      <Title>{headerTitle ? headerTitle : ""}</Title>
      <div style={{ width: "40px", height: "40px" }}>
        {/* <img src={ArrowLeft} /> */}
      </div>
    </HeaderTitle>
  );
};

const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  /* flex: 1 0 0; */
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #eee;

  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */

  box-sizing: border-box;
`;

const Title = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: left;
  color: #333;
`;
